/* eslint-disable indent */
import actions from "../constants/cashBookingActions";
// import { combineReducers } from "redux";

const initialState = {
  val: 1,
};

const childPacketReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.OPEN_CAL:
      return { ...state, val: payload };
    case actions.OPEN_CAL_SUCCESS:
      return { ...state, val: payload };
    case actions.OPEN_CAL_ERROR:
      return state;
    case actions.OPEN_CAL_CLEAR:
      return { val: !state.visible };
    case actions.OPEN_CAL_ADD:
      return { val: +state.val + 1 };
    case actions.OPEN_CAL_SUB:
      return { val: +state.val - 1 };
    default:
      return state;
  }
};

export default childPacketReducer;
